import { createGlobalStyle } from 'styled-components';
import style from 'styled-theming';

const getBackground = style('mode', {
  light: '#EEE',
  dark: '#1d1b1b',
});

const getForeground = style('mode', {
  light: '#1d1b1b',
  dark: '#EEE',
});

const getForegroundGray = style('mode', {
  light: '#877b7b',
  dark: '#d0d0d0',
});

export const skillsColor = style('mode', {
  light: '#405066',
  dark: 'rgb(112 155 241)',
});

const GlobalStyle = createGlobalStyle`
      body {
        background-color: ${getBackground};
        color: ${getForeground};
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      }
      #description{ 
        color: ${getForegroundGray};
      }
 
      #skillsSection{
        color:${skillsColor};
      }
         `;

export default GlobalStyle;
